import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Usuario } from '../../models/usuario';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { Observable } from 'rxjs/Observable';
import { modalComponent } from '../../utils/modal/modal.component';
import { MatDialog } from '@angular/material';
import { utils } from '../../utils/utils';
import { Personal } from '../../models/personal';

@Component({
  selector: 'my-usuario-addedit',
  styles: [],
  templateUrl: './usuarioAddEdit.component.html',
  providers: [generalService]
})

export class usuarioAddEditComponent implements OnInit {
  public usuario: Usuario;
  usuarioAgregar: FormGroup;
  titulo = 'Agregar';
  public personal: any[];
  public preguntas: any[];
  public companias: any[];
  public sucursal: any[];
  personalFiltradas: any;
  preguntasFiltradas: any;
  companiasFiltradas: any;
  sucursalesFiltradas: any;
  personalCtrl: FormControl;
  preguntasCtrl: FormControl;
  companiaCtrl: FormControl;
  sucursalCtrl: FormControl;
  public minDate: any;
  fechaContraVista: any;
  public _utils: utils;
  public usuarioSession: any;
  public loadSucces = false;

  constructor(private formBuilder: FormBuilder, private _generalService: generalService, public dialog: MatDialog, public dataService: DataService) {
    this.usuario = new Usuario();
    this.dataService.guardado = false;
    this.personalCtrl = new FormControl();
    this.preguntasCtrl = new FormControl();
    this.minDate = new Date(2000, 0, 1);
    this._utils = new utils();
  }

  ngOnInit() {
      // this.buildForm();
      this.consultarUsuarioSession();

  }

  cerrarModal() {
    this.dataService.dialogRef.close();
  }

  buildForm() {
    if (this.usuarioSession.COMPANY_ID === null  || this.usuarioSession.COMPANY_ID === undefined ) {
      this.usuarioAgregar = this.formBuilder.group({
        USER_NAME: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
        ECRYPTED_PASSWORD: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
        COMPANY_ID: this.formBuilder.control(null, [Validators.required]),
        ORGANIZATION_ID: this.formBuilder.control(null, [Validators.required]),
        // ECRYPTED_ANSWER: this.formBuilder.control(null, [Validators.maxLength(101)]),
        // ECRYPTED_FOUNDATION: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
         ASK: this.formBuilder.control(null),
        // DESCRIPTION: this.formBuilder.control(null, [Validators.maxLength(250)]),
        // PASSWORD_DATE: this.formBuilder.control(null, [Validators.maxLength(10)]),
        // PASSWORD_LIFE_DATE: this.formBuilder.control(null, [Validators.maxLength(50)]),
        PERSON_ID: this.formBuilder.control(null),
        EMAIL: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101), Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)]),
      });
    } else {
      this.usuarioAgregar = this.formBuilder.group({
        USER_NAME: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
        ECRYPTED_PASSWORD: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
        COMPANY_ID: this.formBuilder.control(null, [Validators.required]),
        ORGANIZATION_ID: this.formBuilder.control(null, [Validators.required]),
        // ECRYPTED_ANSWER: this.formBuilder.control(null, [Validators.maxLength(101)]),
        // ECRYPTED_FOUNDATION: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
         ASK: this.formBuilder.control(null),
        // DESCRIPTION: this.formBuilder.control(null, [Validators.maxLength(250)]),
        // PASSWORD_DATE: this.formBuilder.control(null, [Validators.maxLength(10)]),
        // PASSWORD_LIFE_DATE: this.formBuilder.control(null, [Validators.maxLength(50)]),
        PERSON_ID: this.formBuilder.control(null),
        EMAIL: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101), Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)]),
      });
    }

  }

  buscarUsuario() {
      this._generalService.metodoCall('usuario/consultarUsuario/' + this.usuario.USER_ID).subscribe(
        (result) => {
          if (result == '[]') {
              this.dataService.mensajeAlert = 'El usuario seleccionado ya no se encuentra disponible';
              this.cerrarModal();
          } else {
            this.usuario = JSON.parse(result.replace('[', '').replace(']', ''));
            const fechas = this.usuario.PASSWORD_DATE.split('/');
            this.fechaContraVista = new Date(fechas[2], fechas[1] - 1, fechas[0]);
            /*
            let params: any = {};
            params.value = this.usuario.COMPANY_ID;
            this.getPersonalPorCompania(params); */
          }
        },
        (error) => {
          const errorMsj =  error as any;
          console.log(errorMsj);
        }
      );
  }

  onKeyUpPersonal(event: any): void {
    this.personalFiltradas = this.personalFilter(event.target.value);
  }

  onKeyUpPreguntas(event: any): void {
    this.preguntasFiltradas = this.preguntasFilter(event.target.value);
  }

  personalFilter(val: string): Observable<any> {
    let arr: any[];
    if (val) {
      arr = this.personal.filter((s) => new RegExp(`^${val}`, 'gi').test(s.NAME));
    } else {
      arr = this.personal;
    }
    return Observable.of(arr);
  }

  preguntasFilter(val: string): Observable<any> {
    let arr: any[];
    if (val) {
      arr = this.preguntas.filter((s) => new RegExp(`^${val}`, 'gi').test(s.MEANING));
    } else {
      arr = this.preguntas;
    }
    return Observable.of(arr);
  }

  companiasFilter(val: string): Observable<any> {
    let arr: any[];
    if (val) {
      arr = this.companias.filter((s) => new RegExp(`^${val}`, 'gi').test(s.Nombre));
    } else {
      arr = this.companias;
    }
    return Observable.of(arr);
  }

  sucursalesFilter(val: string): Observable<any> {
    let arr: any[];
    if (val) {
      arr = this.sucursal.filter((s) => new RegExp(`^${val}`, 'gi').test(s.NAME));
    } else {
      arr = this.sucursal;
    }
    return Observable.of(arr);
  }


  getPreguntas() {
      this._generalService.metodoCall('misc/consultarLookup/ASK').subscribe(
        (result) => {
          this.preguntas = JSON.parse(result);
          this.preguntasFiltradas = this.preguntasFilter('');
        },
        (error) => {
          const errorMsj =  error as any;
          console.log(errorMsj);
        }
      );
  }

  getCompanias() {
    this._generalService.metodoCall('compania/consultarCompanias/').subscribe(
      (result) => {
        this.companias = JSON.parse(result);
        this.companiasFiltradas = this.companiasFilter('');
      },
      (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj);
      }
    );
  }

  getSucursales(){
    this._generalService.metodoCall('compania/consultarSucursales/').subscribe(
      (result) => {
        this.sucursal = JSON.parse(result);
        this.sucursalesFiltradas = this.sucursalesFilter('');
      },
      (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj);
      }
    );
  }

  getPersonal() {
    const personalParams = new Personal();
    this._generalService.metodoCall('personal/consultarPersonalAll/').subscribe(
        (result) => {
          this.personal = JSON.parse(result);
          this.personalFiltradas = this.personalFilter('');
        },
        (error) => {
          const errorMsj =  error as any;
          console.log(errorMsj);
        }
      );
  }

  /*
  getPersonalPorCompania(event: any) {
    if (this.usuarioSession.COMPANY_ID === null  || this.usuarioSession.COMPANY_ID === undefined ) {
    this._generalService.metodoCall('personal/consultarPersonalesPorCompania/' + event.value).subscribe(
        (result) => {
          this.personal = JSON.parse(result);
          this.personalFiltradas = this.personalFilter('');
        },
        (error) => {
          const errorMsj =  error as any;
          console.log(errorMsj);
        }
      );
    }
  }*/

  consultarUsuarioSession() {
    const usuario: any = {};
    usuario.loacs = sessionStorage.getItem('acslo');
    this._generalService.metodoCallParams(usuario, 'usuario/consultarUsuarioSession/').subscribe(
      (result) => {
        this.usuarioSession = JSON.parse(result)[0];

        // this.personalFiltradas = this.personalFilter('');
      },
      (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj);

      },
      () => {
        this.loadSucces = true;
        this.buildForm();
        this.getPreguntas();
        /*
        if (this.usuarioSession.COMPANY_ID !== null && this.usuarioSession.COMPANY_ID !== undefined ) {
          this.getPersonal();
        }*/
        this.getCompanias();
        this.getSucursales();
        this.getPersonal();
        if (this.dataService.tipo == 'editar') {
          this.titulo = 'Editar';
          this.usuario.USER_ID = this.dataService.id;
          this.buscarUsuario();
        }
        this.dataService.mensajeAlert = '';
      }
    );
  }

  onSubmit() {
      // let fechaI = this._utils.changeFormatDate(this.fechaContraVista._d || this.fechaContraVista, "yyyy-mm-dd");
      // let regx = /^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/;
      // if(!regx.test(fechaI) )
      // {
        //  this.modal("alert", "La fecha de contraseña no tiene el formato correcto (día/mes/año)");
      // }
      // else{
        let tipo = 'agregar';
        let metodo = 'usuario/insertarUsuario/';
        if (this.dataService.tipo == 'editar') {
          metodo = 'usuario/actualizarUsuario/' + this.usuario.USER_ID;
          tipo = 'editar';
        }

        // this.usuario.PASSWORD_DATE = fechaI;
        this.usuario.PASSWORD_DATE = '2018-12-31';
        // this.usuario.ASK_ID = 1;
       // s this.usuario.PERSON_ID = 340;

        this.usuario.PASSWORD_LIFE_DATE = null;
        this.usuario.loacs = sessionStorage.getItem('acslo');

        this._generalService.metodoCallParamsPutPost(tipo, this.usuario, metodo).subscribe(
            (result) => {
              if (result != '') {
                this.dataService.mensajeAlert = result;
              } else {
                this.dataService.guardado = true;
              }
              this.cerrarModal();
            },
            (error) => {
              const errorMsj =  error as any;
              console.log(errorMsj);
            }
        );
     // }
  }

  modal(tipo, mensaje) {
    this.dataService.modal = tipo;
    this.dataService.mensaje = mensaje;
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogModal = dialogModal;
  }
}



// WEBPACK FOOTER //
// ./src/app/usuario/agregar-editar/usuarioAddEdit.component.ts